import React from 'react';

class TwitterWidget extends React.Component {
  componentDidMount() {
    const script = document.createElement('script');

    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;

    script.onload = () => {
      window.twttr.widgets.load();
    };

    document.body.appendChild(script);
  }
  render() {
    const { channel = 'toisports' } = this.props;
    return (
      <div className="mb24">
        <a
          className="twitter-timeline"
          data-height="450"
          href={`https://twitter.com/${channel}`}
        >
          Tweets by {channel}
        </a>
      </div>
    );
  }
}

export default TwitterWidget;
